<template>
  <div class="small-card">
    <div v-if="details.fetching" class="small-card__loading">
      <span class="loading-dot-blink">{{ $t('label.loading') }} <span>.</span><span>.</span><span>.</span></span>
    </div>
    <div v-else class="small-card__content">
      <div class="small-card__picture" :class="{ 'is-reactive': reactive }">
        <nuttrema-iconica-sidebar-link
           class="no-hover"
           size="picture"
          :icon="icon"
          :theme="theme"
          :picture="picture">
        </nuttrema-iconica-sidebar-link>
      </div>
      <div class="small-card__text">
        <div v-if="name" class="small-card__text__name" :title="name">
          <span>{{ name }}</span>
        </div>
        <div  v-if="description" class="small-card__text__info" :class="{ 'is-reactive': reactive }" :title="description">
          <span>{{ description }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

export default {
  name: 'small-card-abstract',
  props: {
    details: {
      required: true,
      default: null,
    },
    reactive: {
      type: Boolean,
      required: false,
      default: true,
    },
    fetching: {
      type: Boolean,
      required: false,
      default: false,
    },
    icon: {
      required: false,
      default: null,
    },
    image: {
      required: false,
      default: null,
    },
    theme: {
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaIconicaSidebarLink,
  },
  computed: {
    picture() {
      const dir = process.env.IMAGES_ROOT;
      const path = get(this.image, 'path', false);
      const filename = get(this.image, 'thumbnails.large.filename', false);
      return dir && path && filename ? `${dir}${path}${filename}` : null;
    },
    name() {
      return get(this.details, 'data.name', null);
    },
    description() {
      return get(this.details, 'data.description', null);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";
  .small-card {
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    .small-card__loading {
      display: flex;
      align-items: center;
      > span {
        flex-grow: 1;
        align-self: center;
      }
    }

    .small-card__content {
      display: flex;
      align-self: stretch;

      .small-card__picture {
        margin-right: 0.5em;
        display: flex;
        align-self: stretch;
        justify-content: center;
        > * {
          align-self: center;
        }
      }

      .small-card__text {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .small-card__text__name {
          height: 1.5em;
          line-height: 1.5;
          font-weight: 500;
        }

        .small-card__text__info {
          height: 1em;
          line-height: 1;
          font-size: 0.85rem;
          color: $gray-light;
        }

        .small-card__text__name, .small-card__text__info {
          width: 100%;
          position: relative;
          > span {
            position: absolute;
            top: 0; right: 0; bottom: 0; left: 0;
            display: inline-block;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }

    }

    .is-expanded & {
      .small-card__picture.is-reactive,
      .small-card__text__info.is-reactive {
        display: none;
      }
      .small-card__text__name.is-reactive {
        font-weight: 500;
      }
    }

    &.is-in-section {
      padding: 0.5em 0.75em 0.5em;
      background-color: #fff;
      .small-card__text__name {
        font-weight: 500;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/card/small-card-abstract.vue